"use strict";
// Source: tokens
Object.defineProperty(exports, "__esModule", { value: true });
var tokens = {
    defaultBorderRadius: '3px',
    circularRadius: '50%',
    pillRadius: '500em',
    borderRadius0: '0',
    borderRadius1: '3px',
    borderRadius2: '6px',
    borderRadiusPill: '500em',
    borderRadiusCircular: '50%',
    breakpointMobile: '320px',
    breakpointMobileLarge: '576px',
    breakpointTablet: '768px',
    breakpointDesktop: '992px',
    breakpointLarge: '1200px',
    breakpointWidescreen: '1920px',
    colorWhite: 'rgb(255, 255, 255)',
    colorBlack: 'rgb(20, 20, 20)',
    colorBlue: 'rgb(34, 112, 238)',
    colorBlueGrey: 'rgb(140, 156, 165)',
    colorOrange: 'rgb(255, 145, 22)',
    colorYellow: 'rgb(255, 201, 2)',
    colorGreen: 'rgb(31, 188, 112)',
    colorCyan: 'rgb(8, 191, 223)',
    colorPurple: 'rgb(105, 84, 192)',
    colorRed: 'rgb(249, 77, 50)',
    colorMagenta: 'rgb(181, 45, 136)',
    colorBlue100: 'rgb(236, 244, 253)',
    colorBlue200: 'rgb(169, 209, 255)',
    colorBlue300: 'rgb(86, 164, 255)',
    colorBlue400: 'rgb(34, 112, 238)',
    colorBlue500: 'rgb(19, 96, 217)',
    colorBlue600: 'rgb(0, 76, 195)',
    colorNeutral0: 'rgb(255, 255, 255)',
    colorNeutral10: 'rgb(252, 252, 252)',
    colorNeutral20: 'rgb(250, 250, 250)',
    colorNeutral30: 'rgb(247, 247, 247)',
    colorNeutral40: 'rgb(245, 245, 245)',
    colorNeutral50: 'rgb(238, 238, 238)',
    colorNeutral60: 'rgb(223, 224, 225)',
    colorNeutral70: 'rgb(188, 188, 189)',
    colorNeutral80: 'rgb(158, 158, 160)',
    colorNeutral90: 'rgb(115, 116, 117)',
    colorNeutral100: 'rgb(96, 97, 98)',
    colorNeutral200: 'rgb(68, 68, 69)',
    colorNeutral300: 'rgb(45, 46, 49)',
    colorNeutral400: 'rgb(20, 20, 20)',
    colorBlueGrey100: 'rgb(234, 239, 242)',
    colorBlueGrey200: 'rgb(208, 216, 221)',
    colorBlueGrey300: 'rgb(180, 193, 200)',
    colorBlueGrey400: 'rgb(140, 156, 165)',
    colorBlueGrey500: 'rgb(106, 122, 133)',
    colorBlueGrey600: 'rgb(87, 102, 113)',
    colorOrange100: 'rgb(255, 242, 220)',
    colorOrange200: 'rgb(255, 204, 128)',
    colorOrange300: 'rgb(255, 162, 58)',
    colorOrange400: 'rgb(255, 145, 22)',
    colorOrange500: 'rgb(238, 132, 0)',
    colorOrange600: 'rgb(223, 118, 0)',
    colorYellow100: 'rgb(255, 249, 226)',
    colorYellow200: 'rgb(255, 240, 177)',
    colorYellow300: 'rgb(255, 226, 120)',
    colorYellow400: 'rgb(255, 201, 2)',
    colorYellow500: 'rgb(255, 190, 0)',
    colorYellow600: 'rgb(222, 149, 0)',
    colorGreen100: 'rgb(225, 253, 239)',
    colorGreen200: 'rgb(144, 239, 192)',
    colorGreen300: 'rgb(96, 223, 166)',
    colorGreen400: 'rgb(31, 188, 112)',
    colorGreen500: 'rgb(24, 167, 97)',
    colorGreen600: 'rgb(16, 134, 75)',
    colorCyan100: 'rgb(227, 252, 255)',
    colorCyan200: 'rgb(177, 243, 250)',
    colorCyan300: 'rgb(19, 206, 234)',
    colorCyan400: 'rgb(8, 191, 223)',
    colorCyan500: 'rgb(12, 165, 192)',
    colorCyan600: 'rgb(3, 130, 153)',
    colorPurple100: 'rgb(241, 237, 255)',
    colorPurple200: 'rgb(193, 182, 242)',
    colorPurple300: 'rgb(135, 114, 229)',
    colorPurple400: 'rgb(105, 84, 192)',
    colorPurple500: 'rgb(79, 58, 158)',
    colorPurple600: 'rgb(66, 39, 153)',
    colorRed100: 'rgb(255, 236, 233)',
    colorRed200: 'rgb(255, 178, 160)',
    colorRed300: 'rgb(255, 116, 95)',
    colorRed400: 'rgb(249, 77, 50)',
    colorRed500: 'rgb(230, 55, 23)',
    colorRed600: 'rgb(191, 42, 0)',
    colorMagenta100: 'rgb(251, 234, 245)',
    colorMagenta200: 'rgb(250, 175, 226)',
    colorMagenta300: 'rgb(217, 73, 169)',
    colorMagenta400: 'rgb(181, 45, 136)',
    colorMagenta500: 'rgb(152, 32, 113)',
    colorMagenta600: 'rgb(125, 22, 91)',
    durationNone: '0ms',
    durationFast: '100ms',
    durationStandard: '200ms',
    durationSlow: '300ms',
    easingStandard: 'cubic-bezier(.4, 0, .2, 1)',
    easingIn: 'cubic-bezier(.4, 0, 1, 1)',
    easingOut: 'cubic-bezier(0, 0, .4, 1)',
    easingInOut: 'cubic-bezier(.4, 0, .6, 1)',
    fontWeightRegular: '400',
    fontWeightBold: '600',
    opacityHover: '.8',
    opacityDisable: '.6',
    opacityHovered: '.8',
    opacityDisabled: '.6',
    shadowSize0: '0 0 0',
    shadowSize1: '0 1px 2px',
    shadowSize2: '0 2px 8px',
    shadowSize3: '0 8px 24px',
    shadowColor: 'rgba(20, 20, 20, .1)',
    shadowColorActive: 'rgba(34, 112, 238, .2)',
    shadowColorError: 'rgba(230, 55, 23, .2)',
    shadowFocus: '0 0 0 3px rgba(169, 209, 255, 1)',
    shadowFocusInset: 'inset 0 0 0 3px rgba(169, 209, 255, 1)',
    spacing0: '0',
    spacing1: '8px',
    spacing2: '16px',
    spacing3: '24px',
    spacing4: '32px',
    spacing5: '48px',
    spacing6: '64px',
    spacing7: '96px',
    spacing8: '128px',
    spacingHalf: '4px',
    typescale0: '10px',
    typescale1: '12px',
    typescale2: '14px',
    typescale3: '16px',
    typescale4: '20px',
    typescale5: '26px',
    typescale6: '32px',
    typescale7: '41px',
    baseFontSize: '16px',
    baseLineHeight: '1.5',
    baseFontFamily: '&#x27;Nunito Sans&#x27;, sans-serif',
    displayFontFamily: '&#x27;Sofia Pro&#x27;, SofiaPro, sans-serif',
    displayLineHeight: '1.25',
    zIndexNotification: '1200',
    zIndexOverlay: '1100',
    zIndexGuideHelp: '999',
    zIndexGlobalNav: '990',
    zIndexPopover: '800',
    zIndexModal: '1100',
    zIndexDrawer: '1100'
};
exports.default = tokens;
//# sourceMappingURL=tokens.js.map